/* Ocean Blue story sections — shared scroll engine.
   Safe to include from several sections: it initialises once and re-scans
   whenever the Shopify theme editor loads or reloads a section. */
(function () {
  if (window.OBStory) { return; }
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  document.documentElement.classList.add('ob-js');

  var OB = window.OBStory = { pins: [], paras: [], scrubs: [] };

  /* ---------- Reveal ---------- */
  var revealIO = ('IntersectionObserver' in window) && !RM ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;

  function initReveal(root) {
    root.querySelectorAll('.ob-reveal:not([data-ob-ready])').forEach(function (el) {
      el.setAttribute('data-ob-ready', '');
      if (revealIO) { revealIO.observe(el); } else { el.classList.add('is-in'); }
    });
  }

  /* ---------- Pins + parallax ---------- */
  var ticking = false;
  function update() {
    ticking = false;
    if (RM) { return; }
    var vh = window.innerHeight;
    OB.pins.forEach(function (el) {
      var r = el.getBoundingClientRect(), total = el.offsetHeight - vh;
      if (total <= 0) { return; }
      var p = clamp(-r.top / total, 0, 1);
      el.style.setProperty('--p', p.toFixed(4));
      if (el._obScrub) { el._obScrub(p); }
    });
    OB.paras.forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.style.setProperty('--py', clamp((vh - r.top) / (vh + r.height), 0, 1).toFixed(4));
    });
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  function initPins(root) {
    root.querySelectorAll('[data-ob-pin]:not([data-ob-ready])').forEach(function (el) { el.setAttribute('data-ob-ready', ''); OB.pins.push(el); });
    root.querySelectorAll('[data-ob-parallax]:not([data-ob-ready])').forEach(function (el) { el.setAttribute('data-ob-ready', ''); OB.paras.push(el); });
  }

  /* ---------- Scroll-scrubbed frame sequence ---------- */
  function initScrub(section) {
    var canvas = section.querySelector('canvas[data-ob-scrub]');
    var dataEl = section.querySelector('script[data-ob-frames]');
    if (!canvas || !dataEl) { return; }
    var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var portrait = window.matchMedia('(max-width: 768px)').matches || window.innerHeight > window.innerWidth;
    var urls = (portrait && data.mobile && data.mobile.length) ? data.mobile : data.desktop;
    if (!urls || !urls.length) { return; }
    var n = urls.length, frames = new Array(n), ctx = canvas.getContext('2d');
    var fade = parseFloat(section.getAttribute('data-ob-fade')) || 0.15;
    var ease = parseFloat(section.getAttribute('data-ob-ease')) || 0.12;
    var target = RM ? 0.1 : 0, shown = target, raf = 0, lastKey = '';

    function order(count) { var out = [0, count - 1], step = count - 1; while (step > 1) { step = Math.ceil(step / 2); for (var i = 0; i < count; i += step) { if (out.indexOf(i) < 0) { out.push(i); } } } return out; }
    function nearest(i) { if (frames[i]) { return frames[i]; } for (var d = 1; d < n; d++) { if (i - d >= 0 && frames[i - d]) { return frames[i - d]; } if (i + d < n && frames[i + d]) { return frames[i + d]; } } return null; }
    function paint(img, alpha) {
      var cw = canvas.width, ch = canvas.height, s = Math.max(cw / img.width, ch / img.height), w = img.width * s, h = img.height * s;
      ctx.globalAlpha = alpha; ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h); ctx.globalAlpha = 1;
    }
    // Draw the frame at a fractional position, blending the two neighbouring frames.
    function draw(pos, force) {
      var i0 = Math.floor(pos), i1 = Math.min(i0 + 1, n - 1), f = pos - i0;
      var a = nearest(i0); if (!a) { return; }
      var b = (f > 0.04 && frames[i1]) ? frames[i1] : null;
      var key = i0 + ':' + (b ? Math.round(f * 20) : 0);
      if (!force && key === lastKey) { return; }
      lastKey = key;
      paint(a, 1);
      if (b) { paint(b, f); }
    }
    function captions(p) {
      caps.forEach(function (c) {
        var o = clamp(Math.min((p - c.a) / fade, (c.b - p) / fade), 0, 1);
        o = o * o * (3 - 2 * o); // smoothstep
        c.el.style.opacity = o.toFixed(3);
        c.el.style.transform = 'translateY(' + ((1 - o) * 18).toFixed(1) + 'px)';
      });
    }
    function render(force) { draw(shown * (n - 1), force); captions(shown); }
    function tick() {
      shown += (target - shown) * ease;
      if (Math.abs(target - shown) < 0.0004) { shown = target; }
      render(false);
      raf = (shown !== target) ? window.requestAnimationFrame(tick) : 0;
    }
    function size() { var r = canvas.getBoundingClientRect(); canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr); render(true); }

    var seq = order(n), cursor = 0, active = 0;
    function pump() {
      while (active < 6 && cursor < seq.length) {
        (function (i) {
          var img = new Image(); active++;
          img.decoding = 'async';
          img.onload = function () { frames[i] = img; active--; if (Math.abs(i - shown * (n - 1)) < 2) { render(true); } pump(); };
          img.onerror = function () { active--; pump(); };
          img.src = urls[i];
        })(seq[cursor++]);
      }
    }
    var caps = Array.prototype.map.call(section.querySelectorAll('[data-ob-cap]'), function (el) {
      var r = (el.getAttribute('data-ob-cap') || '0,1').split(',').map(Number); return { el: el, a: r[0], b: r[1] };
    });
    var firstIdx = Math.round(target * (n - 1));
    var first = new Image();
    first.onload = function () { frames[firstIdx] = first; size(); pump(); };
    first.src = urls[firstIdx];
    window.addEventListener('resize', size);

    section._obScrub = function (p) {
      target = p;
      if (!raf) { raf = window.requestAnimationFrame(tick); }
    };
  }

  /* ---------- Sticky chapters ---------- */
  function initChapters(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-ob-media] [data-chapter]'));
    if (!slides.length) { return; }
    // Show the slide for chapter k, or the closest earlier chapter that has an image.
    function activate(k) {
      var pick = null;
      slides.forEach(function (s) { var c = +s.getAttribute('data-chapter'); if (c <= k && (!pick || c > +pick.getAttribute('data-chapter'))) { pick = s; } });
      if (!pick) { pick = slides[0]; }
      slides.forEach(function (s) { s.classList.toggle('is-on', s === pick); });
    }
    section._obChapter = activate;
    if (RM || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { activate(+e.target.getAttribute('data-chapter')); } });
    }, { rootMargin: '-45% 0px -45% 0px' });
    section.querySelectorAll('[data-ob-chapter]').forEach(function (c) { io.observe(c); });
  }

  /* ---------- Film: play only in view ---------- */
  function initFilm(section) {
    var v = section.querySelector('video[data-ob-film], [data-ob-film] video');
    if (!v || !('IntersectionObserver' in window)) { return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { var p = v.play(); if (p && p.catch) { p.catch(function () {}); } } else { v.pause(); } });
    }, { threshold: 0.35 }).observe(v);
  }

  /* ---------- Count-up ---------- */
  function initCounts(section) {
    var els = section.querySelectorAll('[data-ob-count]');
    if (!els.length || RM || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        io.unobserve(e.target);
        var el = e.target, to = parseInt(el.getAttribute('data-ob-count'), 10) || 0, t0 = performance.now();
        (function tick(now) {
          var k = clamp((now - t0) / 1400, 0, 1), v = Math.round(to * (1 - Math.pow(1 - k, 3)));
          el.textContent = v.toLocaleString('en-US');
          if (k < 1) { window.requestAnimationFrame(tick); }
        })(t0);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Ambient bubbles ---------- */
  function initBubbles(section) {
    var bc = section.querySelector('canvas[data-ob-bubbles]');
    if (!bc || RM) { return; }
    var bx = bc.getContext('2d'), bw = 0, bh = 0, bubbles = [], running = false, raf = 0;
    function spawn() { return { x: Math.random() * bw, y: bh + Math.random() * bh, r: (1 + Math.random() * 3) * dpr, v: (0.25 + Math.random() * 0.6) * dpr, w: Math.random() * Math.PI * 2, a: 0.25 + Math.random() * 0.5 }; }
    function size() { var r = bc.getBoundingClientRect(); bw = bc.width = Math.round(r.width * dpr); bh = bc.height = Math.round(r.height * dpr); bubbles = []; for (var i = 0; i < Math.round(bw / dpr / 26); i++) { bubbles.push(spawn()); } }
    function step() {
      if (!running) { return; }
      bx.clearRect(0, 0, bw, bh);
      bubbles.forEach(function (b) {
        b.y -= b.v; b.w += 0.02;
        var x = b.x + Math.sin(b.w) * 6 * dpr;
        if (b.y < -10) { var s = spawn(); b.x = s.x; b.y = bh + 10; b.r = s.r; b.v = s.v; b.a = s.a; }
        bx.beginPath(); bx.arc(x, b.y, b.r, 0, Math.PI * 2); bx.strokeStyle = 'rgba(185,213,232,' + b.a + ')'; bx.lineWidth = dpr * 0.8; bx.stroke();
      });
      raf = window.requestAnimationFrame(step);
    }
    size(); window.addEventListener('resize', size);
    new IntersectionObserver(function (es) { es.forEach(function (e) { running = e.isIntersecting; if (running) { step(); } else { window.cancelAnimationFrame(raf); } }); }).observe(bc);
  }

  /* ---------- Init ---------- */
  function init(root) {
    root = root || document;
    initReveal(root); initPins(root);
    var sections = root.matches && root.matches('[data-ob-section]') ? [root] : root.querySelectorAll('[data-ob-section]');
    Array.prototype.forEach.call(sections, function (s) {
      if (s.getAttribute('data-ob-init')) { return; }
      s.setAttribute('data-ob-init', '1');
      initScrub(s); initChapters(s); initFilm(s); initCounts(s); initBubbles(s);
    });
    update();
  }
  OB.init = init;

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Theme editor: selecting a chapter block shows its image in the pinned panel.
  document.addEventListener('shopify:block:select', function (e) {
    var ch = e.target && e.target.closest && e.target.closest('[data-ob-chapter]');
    var sec = ch && ch.closest('[data-ob-section]');
    if (sec && sec._obChapter) { sec._obChapter(+ch.getAttribute('data-chapter')); }
  });
})();
